import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const offerSection = document.getElementById('offer');
      if (!offerSection) return;
      const offerTop = offerSection.offsetTop;
      const scrollPosition = window.scrollY + window.innerHeight;
      if (window.scrollY > 2000 && scrollPosition < offerTop - 200) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!visible) return null;
  return <motion.div initial={{
    y: 100,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.35
  }} className="fixed bottom-0 left-0 right-0 z-50 flex justify-center pb-6 pt-3 px-4 md:hidden" data-id="element-175">
      <CTAButton href="https://www.imaginovem.com/cart/48473009488122:1" trackEvent="StickyCheckoutClick" className="w-full max-w-md text-lg py-4" data-id="element-176">
        ¡QUIERO MI COPIA AHORA!
      </CTAButton>
    </motion.div>;
}